import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import { urlApi } from '../../../api/url.api';
import { postApi } from '../../../api/call.api';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';
import DateRange from '../../../components/DateRange/DateRange';
import DateFilterInfoPopup from '../../../components/Popover/DateFilterInfoPopup';

const OrganicInorganicChart = () => {

    const [selected, setSelected] = useState(2);
    const [date, setDate] = useState({ startDate: '', endDate: '' });

    const [series, setSeries] = useState([{
        name: 'Organic Installs',
        data: [0, 0, 0, 0, 0, 0, 0]
    }, {
        name: 'Inorganic Installs',
        data: [0, 0, 0, 0, 0, 0, 0]
    }])

    const [options, setOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false,
                allowMouseWheelZoom: false,
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                    total: {
                        enabled: false,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        xaxis: {
            categories: [],
        },
        legend: {
            position: 'bottom',
            offsetY: 10
        },
        fill: {
            opacity: 1
        }
    });

    const getData = async () => {
        let postData = {
            filter: selected
        }
        if (selected == 3) {
            postData["startDate"] = dateIntoYYYY_MM_DD(date.startDate);
            postData["endDate"] = dateIntoYYYY_MM_DD(date.endDate);
        }

        let resp = await postApi(postData, urlApi?.getOrganicInorganicGraphData);

        if (resp.responseCode === 200) {

            let localOrganic = [];
            let localInorganic = [];
            let localX = [];

            for (const item of resp?.data) {
                if (selected == 1) {
                    let count = item?.hour + 1;
                    localX.push((count > 11 ? (count == 24 ? (count - 12) + "AM" : (count == 12 ? count : (count - 12)) + "PM") : (count + "AM")));
                }
                if (selected != 1) {
                    localX.push(item?.date);
                }
                localOrganic.push(item.organicInstalls || 0);
                localInorganic.push(item.inOrganicInstalls || 0);
            }

            setSeries([
                {
                    name: 'Organic Installs',
                    data: localOrganic
                },
                {
                    name: 'Inorganic Installs',
                    data: localInorganic
                }
            ])

            setOptions({ ...options, xaxis: { ...options.xaxis, categories: localX, type: selected == 1 ? 'time' : 'datetime' } });

        } else {
            setSeries([
                {
                    name: 'Organic Installs',
                    data: [0, 0, 0, 0, 0, 0, 0]
                },
                {
                    name: 'Inorganic Installs',
                    data: [0, 0, 0, 0, 0, 0, 0]
                }
            ])
        }
    }

    useEffect(() => {
        if (selected == 3 && !date?.startDate) {
            return
        }
        getData();
    }, [selected, date])

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    function handleOnChange(value) {
        setSelected(parseInt(value));
        if (value !== 3) {
            setDate({ startDate: '', endDate: '' })
        }
    }

    return (
        <div className='mb-4 bg-white p-2 rounded-lg'>
            <div className="flex items-center gap-2 flex-wrap">
                <p className='mb-0 text-md font-bold text-[var(--grey)]'>Organic & Inorganic Install Clicks</p>
                <div className='flex ms-auto gap-2'>
                    <select name="" id="" className='form-control form-control-sm' defaultValue={selected} onChange={(e) => { handleOnChange(e?.target?.value) }}>
                        <option value="1">Today</option>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Custom</option>
                    </select>
                </div>
                {selected == 3 && <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />}
                {date?.startDate && <DateFilterInfoPopup />}
            </div>
            <Chart options={options} series={series} height={'360px'} type="bar" />
        </div>
    )
}

export default OrganicInorganicChart